import {CommonModule} from '@angular/common';
import {Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef} from '@angular/core';
import {environment} from '@env/environment';
import type {AiChatComponent} from './ai-chat.component';

@Component({
    selector: 'app-ai-chat-launcher',
    standalone: true,
    imports: [CommonModule],
    template: `
        <button *ngIf="!chat" class="ai-orb" type="button" (click)="load()" [disabled]="loading"
            [attr.aria-label]="loading ? 'Cargando asistente…' : 'Abrir asistente ' + companyName + ' AI'">
            <span class="ai-orb-spin"></span>
            <svg class="ai-sparkle" viewBox="0 0 24 24" width="24" height="24" fill="white" aria-hidden="true">
                <path d="M12 2l1.9 6.1L20 10l-6.1 1.9L12 18l-1.9-6.1L4 10l6.1-1.9L12 2z"/>
                <path d="M19 14l.9 2.6L22.5 17.5l-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9L19 14z" opacity="0.85"/>
            </svg>
        </button>
        <span *ngIf="failed" class="ai-load-error" role="alert">No se pudo abrir el asistente. Pulsa para reintentar.</span>
        <ng-template #host></ng-template>
    `,
    styleUrls: ['./ai-chat-launcher.component.css']
})
export class AiChatLauncherComponent implements OnDestroy {
    @ViewChild('host', {read: ViewContainerRef, static: true}) host: ViewContainerRef;
    readonly companyName = environment.company;
    chat?: ComponentRef<AiChatComponent>;
    loading = false;
    failed = false;
    private destroyed = false;
    protected loadComponent = () => import('./ai-chat.component').then(module => module.AiChatComponent);

    async load(): Promise<void> {
        if (this.loading || this.chat || this.destroyed) return;
        this.loading = true;
        this.failed = false;
        try {
            const component = await this.loadComponent();
            if (this.destroyed) return;
            this.chat = this.host.createComponent(component);
            this.chat.instance.toggle();
            this.chat.changeDetectorRef.detectChanges();
            this.chat.location.nativeElement.querySelector('.ai-panel-frame')?.focus();
        } catch {
            this.chat?.destroy();
            this.chat = undefined;
            this.failed = true;
        } finally {
            this.loading = false;
        }
    }

    ngOnDestroy(): void { this.destroyed = true; }
}
